// 手机号
export function validaItePhone(rule, value, callback) {
  rule = /^1\d{10}$/;
  if (!value) {
    callback(new Error('请输入手机号'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
    callback();
  }
}

// 手机号非必填
export function validaIteNoPhone(rule, value, callback) {
  rule = /^1\d{10}$/;
  if (value && !rule.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
    callback();
  }
}

// 银行账户
export function validateCardNo(rule, value, callback) {
  rule = /^\d+$/;
  if (!value) {
    callback(new Error('请输入您的银行卡号'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的银行卡号'));
  } else {
    callback();
  }
}
